import { render, staticRenderFns } from "./PageCategoriesGEMRCN.vue?vue&type=template&id=8894e7c6&"
import script from "./PageCategoriesGEMRCN.vue?vue&type=script&lang=js&"
export * from "./PageCategoriesGEMRCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports